import './post_view.js.coffee'
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.FacebookPostView extends Monitoring.Reports.DailyInsights.PostView
  preview: JST['backbone/templates/monitoring/reports/daily_insights/post_preview_facebook']

  customRender: =>
    @sections.push(new Monitoring.Reports.DailyInsights.FacebookPostPreviewView(@options))
    @sections.push(new Monitoring.Reports.DailyInsights.FacebookMetricsView(@options))
